import {STORE_CUSTOMER_LOAN, STORE_EMPLOYEE_LOAN, STORE_ZELLE_LOAN} from '../../constants/loan';

const initialState = {
    customerLoanHistory: {},
    employeeLoanHistory: {},
    zelleHistory: {},
    zelleTotalBalance: null,
    zelleTable: []
};

export default (state = initialState, action) => {
    switch (action.type) {
        case STORE_CUSTOMER_LOAN:
            return {
                ...state,
                customerLoanHistory: action.loanHistory
            }
         case STORE_EMPLOYEE_LOAN:
            return {
                ...state,
                employeeLoanHistory: action.shortHistory
            }

        case STORE_ZELLE_LOAN:
            return {
                ...state,
                zelleHistory: action.zelleHistory,
                zelleTotalBalance: action.totalBalance,
                zelleTable: action.zelleTable
            }
        default:
            return state
    }
};
